import { Component, input, output } from '@angular/core';
import { InputOtpModule } from 'primeng/inputotp';

import {
  ControlContainer,
  FormGroupDirective,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { SharedModule } from 'src/app/core/shared.module';

@Component({
  selector: 'v-otp-input',

  imports: [ReactiveFormsModule, SharedModule, FormsModule, InputOtpModule],
  templateUrl: './otp.component.html',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class VOTPInputComponent {
  readonly size = input<'sm' | 'md' | 'lg'>('md');

  /**
   * Optional form control name
   */
  readonly fControlName = input<string>();

  /**
   * Optionally sets the test id for the input
   */
  readonly testId = input<string>();

  /**
   * Emits when the user presses enter
   */
  submitCode = output<Event>();

  onEnter(event: Event) {
    this.submitCode.emit(event);
  }
}
